import React from 'react';
import Login from './Components/Login/Login'; // Importa directamente desde la ubicación correcta

function App() {
    return (
        <div>
            <Login />
        </div>
    );
}

export default App;
